var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"breadcrumb"},[_c('a',{staticClass:"breadcrumb-item",attrs:{"href":"#"}},[_vm._v("Home")]),_c('a',{staticClass:"breadcrumb-item",attrs:{"href":"#"}},[_vm._v("Library")]),_c('a',{staticClass:"breadcrumb-item active",attrs:{"href":"#"}},[_vm._v("Data")])])
}]

export { render, staticRenderFns }